export default [
    {
        path: '/management',
        name: 'management',
        component: () => import('@/views/Sms/SmsManagement/SmsManagement'),
    },
    {
        path: '/management/:id',
        name: 'detail',
        component: () => import('@/views/Sms/SmsDetail/SmsDetail'),
    },
    ...(process.env.VUE_APP_ENABLE_SMS_SERVICE?.toLowerCase() === 'true'
        ? [
              {
                  path: '/create-sms',
                  name: 'create-sms',
                  component: () => import('@/views/Sms/CreateSms/CreateSms'),
              },
          ]
        : []),
    {
        path: '/schedule',
        name: 'schedule',
        component: () => import('@/views/Sms/Schedule/Schedule'),
    },
    {
        path: '/brand-names',
        name: 'brand-names',
        component: () => import('@/views/Sms/BrandNames/BrandNames'),
    },
    ...(process.env.VUE_APP_ENABLE_SMS_SERVICE?.toLowerCase() === 'true'
        ? [
              {
                  path: '/manual',
                  name: 'manual',
                  component: () => import('@/views/Sms/Manual/Manual'),
              },
          ]
        : []),
];
